module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-5.7f11fdea.png";